<p>e-edit-profile works!</p>

<link rel="stylesheet" href="//use.fontawesome.com/releases/v5.0.7/css/all.css">
<script src="https://use.fontawesome.com/29ecae9da7.js"></script>

<div class="edit-address" >
     <div class="address-left" >
        
        <h1 style="font-size: 24px;">MY ACCOUNT</h1>
        <li>Account information</li>
        <a class="order" >My Orders</a>
        <a class="logout" >Log out</a>
     </div><!--end left-->

     <div class="vl" ></div>

     <div class="address-right" >
      <p>Select addresses</p>

      <label class="has-text-input" >
       <input (click)="toggle(1)" type="radio" name="radios" value="alien"><span class="outside"><span class="inside"></span></span>
       <div id="selected1" style="border:3px dashed ;padding-left: 15px;padding-top:15px;padding-bottom:10px;width: 100%;">
          <p style="font-weight: bold;font-size: 12px;">Joseph silly</p>
          <p>368 Kingston road</p>
          <p>Wimbledon chase</p>
          <p>London</p>
          <p>SW20 8LN</p>
          <i class="bx bx-home" style="font-size:20px;position: absolute;right: 5%;top:50%;" ></i>
     </div>
     </label>

     <label class="has-text-input" >
       <input  (click)="toggle(2)" type="radio" name="radios" value="alien"><span class="outside"><span class="inside"></span></span>
       <div id="selected2" style="border:3px dashed;
       padding-left: 15px;
       padding-top: 15px;
       padding-bottom: 10px;
       width: 100%;">
          <p style="font-weight: bold;font-size: 12px;" >Soorya sukumar</p>
          <p>68, swarnapuri enclave</p>
          <p>Race course</p>
          <p>Coimbatore</p>
          <p>620165</p>
        <i class="bx bx-briefcase" style="font-size:20px;position: absolute;right: 5%;top:50%;" ></i>
     </div>
     </label>

     <button>Confirm</button>
     <a href="editaddress" style="background-color: #fff;border:1px solid #000;color:#000; padding: 10px; margin-left: 30px;" >Edit your address</a>

     </div><!--end right-->
</div><!--end edit address-->

